export default "__VITE_ASSET__DdqXhC5d__"